import React from 'react'
import { compose, lifecycle } from 'recompose'
import { updateObject } from 'helpers/objectHelpers'
import FormLanguage from 'components/forms/FormLanguage'
import isEmpty from 'lodash/isEmpty'
import _ from 'lodash'

const DividerContent = ({
  value,
  valueContent,
  valueContent: {
    text = {},
  },
  valueSettings,
  handleUpdate
}) => {
  const handleChange = (val ) => {
    const newData = Object.assign(value, { defaultContent: { text:{ en: val.en , th: val.th }}}, {defaultSettings: { ...valueSettings, horizontal: !isEmpty(val.en)}})
    return handleUpdate(value, newData)
  }

  return (
    <div>
      <FormLanguage
        value={text}
        onChange={(val) => handleChange(val)}
      />
    </div>
  )
}


DividerContent.propTypes = {}
DividerContent.defaultProps = {}

export default DividerContent



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/divider/DividerContent.js